import { Icon, Text, style } from '@do/walrus';

import classNames from 'classnames';
import React, { ReactNode, ReactElement } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  border-radius: ${style.vars.borderRadius.base};
  padding: ${style.vars.whitespace.regular} ${style.vars.whitespace.medium};
  margin: ${style.vars.whitespace.small} 0;

  &.is-error {
    background-color: ${style.colors.red.lightest};
    border: ${style.vars.borderWidth.thin} solid ${style.colors.red.primary};
  }
`;

interface BannerProps {
  type: 'error'; // We can add more types of banners in the future
  title: string;
  details?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  className?: any;
  children?: ReactNode;
}

const Banner = (props: BannerProps): ReactElement => {
  const { type, title, details, className, children } = props;

  const classes = classNames({
    [className]: className,
    'is-error': type === 'error'
  });

  const ICONS = {
    error: 'error'
  };

  return (
    <Container className={classes}>
      <Icon
        icon={ICONS[type]}
        large={true}
        className="do-u-mt--xsmall do-u-mr--regular"
      />
      <div>
        <Text type="small">{title}</Text>
        <Text type="p" className="do-u-textSmall do-u-ma--remove">
          {children ? children : details}
        </Text>
      </div>
    </Container>
  );
};

export default Banner;
